<template>
  <div id="app" ref='id_app'>
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <!-- <GoTop></GoTop> -->
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    // _isMobile() {
    //   let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    //   return flag;
    // }
  },
  mounted() {
    // if (this._isMobile()) {
    //   this.$refs.id_app.style.width = '100%';
    // } else {
    //   this.$refs.id_app.style.width = '1920px';
    // }
  }
}
</script>

<style>
.el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 2px solid #4CAF50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue